/**
 * Checking state: full-screen image while Teams channel is being validated.
 */
import React from "react";
import { Stack } from "@fluentui/react";
import mainPageBackground from "../../../assets/vectorIllustrationTeamWork.svg";

export default function CheckingView({ innerRef, imgStyles }) {
  return (
    <div ref={innerRef}>
      <Stack vertical tokens={{ childrenGap: 0, padding: 0 }}>
        <Stack.Item>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              overflow: "hidden",
              height: "100vh",
            }}
          >
            <img
              id="mainPageBackground"
              src={mainPageBackground}
              style={imgStyles}
              alt="Welcome to Addovation Share"
              loading="eager"
              decoding="sync"
              fetchPriority="high"
            />
          </div>
        </Stack.Item>
      </Stack>
    </div>
  );
}
